import React from "react";
const SvgDsMail = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <g fill="#1A1F24">
      <path d="M12.143 12.258L20 6.375A.208.208 0 0019.874 6H4.126c-.2 0-.285.255-.125.375l7.856 5.883c.086.067.21.067.286 0z" />
      <path d="M12 13.664c-.344 0-.678-.107-.964-.33l-7.699-6.06A.208.208 0 003 7.438v8.895C3 17.253 3.746 18 4.667 18h14.666c.92 0 1.667-.746 1.667-1.667V7.01l-8.036 6.316c-.286.223-.62.33-.964.33v.01z" />
    </g>
  </svg>
);
export default SvgDsMail;
